import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import AllNotesView
  from 'Components/AdvisorApp/Viewport/MissionControl/Page/Versions/Default/Tabs/AllNotes/AllNotes';

const styles = () => ({
  container: {}, // Not used -- just to get around a console error
  root: {},
});

const View = ({
  className,
  classes,
}) => {
  return (
    <AllNotesView className={classNames(classes.root, className)} />
  );
};

View.defaultProps = {
  className: '',
};

View.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(View);
